module.exports = __webpack_public_path__ + "static/media/designMoney.5fba5cdb.webp";